import { Box, CircularProgress, Typography } from '@mui/material';
import MapPoligons from 'components/MapPoligons';
import { poligonStr2List } from 'components/MapPoligons/UtilCalcCordenadas';
import FForm from 'components/form';
import Fazenda from 'entity/Fazenda';
import { useEffect, useState } from 'react';

export default function Mapa() {
  const [fazendas, setFazendas] = useState([])
  const [outrosPoligonos, setOutrosPoligonos] = useState([])
  const [loading, setLoading] = useState(true)

  useEffect(() => {
    const unsubscribe = Fazenda.collection.where("hasMap", "==", true)
      .onSnapshot(snap => {
        let resultFazendas = [];
        let unifiedTalhoes = []
        snap.forEach(doc => resultFazendas.push(doc.data()));
        resultFazendas.forEach((fazenda) => {
          fazenda.talhoesFazenda.forEach((talhao) => {
            if (talhao.areaNoMapStr) {
              unifiedTalhoes.push(talhao)
            }
          })
        })
        setFazendas(unifiedTalhoes);
        setLoading(false);
      }, error => {
        console.error("Error fetching snapshot: ", error);
        setLoading(false);
      });

    return () => unsubscribe();
  }, []);

  useEffect(() => {
    if (fazendas) {
      let ou = [];
      fazendas.forEach(t => {
        let area = t.area || 0
        if (t.nome !== "") {
          if (t.areaNoMapStr) {
            ou.push({
              title: t.nome,
              props: { "Área": area },
              path: poligonStr2List(t.areaNoMapStr)
            })
          }
        }
      });
      setOutrosPoligonos(ou)
    }
  }, [fazendas])

  if (loading) {
    return (
      <Box
        display="flex"
        flexDirection="column"
        gap={2}
        alignItems="center"
        justifyContent="center"
        width="100%"
        height="100%"
        position="relative"
      >
        <CircularProgress size={25} />
        <Typography>Carregando localizações...</Typography>
      </Box>
    )
  }

  return (
    <FForm>
      <MapPoligons name="areaNoMapStr" outrosPoligonos={outrosPoligonos} showCurrentLocation editPermissions={false} />
    </FForm>
  )
}
